import '@angular/compiler';
import localeHr from '@angular/common/locales/hr';
import { registerLocaleData } from '@angular/common';
import { enableProdMode, importProvidersFrom, isDevMode, provideAppInitializer } from '@angular/core';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  PreloadAllModules,
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
  withPreloading,
} from '@angular/router';
import {
  provideServiceWorker,
  ServiceWorkerModule,
} from '@angular/service-worker';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { APP_SETTINGS, appSettingsInitializer, getAppSettings } from './app/providers/runtime-settings';
import { tokenInterceptor } from './app/providers/token.interceptor';
import { errorInterceptor } from './app/providers/error.interceptor';
import { offlineQueueInterceptor } from './app/providers/offline-queue.interceptor';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeHr);

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding()
    ),
    provideIonicAngular({
      backButtonText: 'Natrag',
    }),
    provideHttpClient(
      withInterceptors([tokenInterceptor, errorInterceptor, offlineQueueInterceptor])
    ),
    importProvidersFrom(
      IonicStorageModule.forRoot(),
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
      })
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideAppInitializer(appSettingsInitializer()),
    { provide: APP_SETTINGS, useFactory: getAppSettings },
  ],
}).catch(err => console.error(err));
